<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="WasteBinReadings"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="wasteBinReadings"
    :headerTitle="'Waste Bin Readings'|gettext"
    :items="ds"
    export-to-csv
    :exportToCsvFilename="'waste-bin-readings'|pgettext('ExportFilename')"
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    :contextMenu="b_2248226175642056_contextMenu"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @contextmenu:remove="evh_2248226175642056_contextmenuRemove($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DIV
        class="mx-2"
      >
        <ItpFormCheckbox
          name="skip_archived"
          :label="'Include handled readings'|pgettext('WasteBinReadings')"
          inline
          v-model="dsParams.include_worksheets"
        >
        </ItpFormCheckbox>
      </DIV>
      <ItpButton
        icon="fa-cog"
        :text="'Create Worksheets...'|gettext"
        size="sm"
        :disabled="!selectedItems || !selectedItems.length"
        variant="primary"
        class="mx-2"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-trash"
        :text="'Delete'|gettext"
        size="sm"
        variant="danger"
        :disabled="!selectedItems || !selectedItems.length"
        :spinning="actions.deleteItems.isRunning"
        class="mx-2"
        @click="evh_6705964765214521_click($event, {})"
      >
      </ItpButton>
      <PageHelp
        path="/assets/fixed-assets.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "wasteBinReadings",
    path: "/waste-bin-readings",
    component: "WasteBinReadings"
  }
)

@Component()
export default class WasteBinReadings extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "WasteBinReadings.dsParams");
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  dsParams!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_waste_bin_readings', { parameters: this.dsParams })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  b_2248226175642056_contextMenu!: any;
  dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns', 'b_2248226175642056_contextMenu'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        dsParams: {
          include_worksheets: false,
        }
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "timestamp",
          name: this.$fn.pgettext("WasteBinReadings", "Reading Time"),
          type: "command",
          formatter: {
            name: "chain",
            formatters: [{
              name: "datetime",
            }
              ,
            {
              name: "link",
              href: "#",
              className: "command-link",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "waste_bin_name",
          name: this.$fn.pgettext("WasteBinReadings", "Bin Name"),
          formatter: {
            name: "routeLink",
            to: "fixedAsset",
            params: {
              id: "waste_bin_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "waste_bin_number",
          name: this.$fn.pgettext("WasteBinReadings", "Bin Number"),
        }
          ,
        {
          field: "waste_bin_capacity",
          name: this.$fn.pgettext("WasteBinReadings", "Capacity (liters)"),
        }
          ,
        {
          field: "state",
          name: this.$fn.pgettext("WasteBinReadings", "State"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "gettext",
              context: "WasteBinReadingStates",
              conversion: "StartCase",
            }
              ,
            {
              name: "badge",
              variantmap: {
                empty: "success",
                full: "warning",
              }
              ,
              variantMapSource: "fieldValue",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rental_name",
          name: this.$fn.pgettext("WasteBinReadings", "Rental"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "rental",
            params: {
              id: "rental_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "client_number",
          name: this.$fn.pgettext("WasteBinReadings", "Client Number"),
          formatter: {
            name: "routeLink",
            to: "company",
            params: {
              id: "client_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "client_name",
          name: this.$fn.pgettext("WasteBinReadings", "Client Name"),
          formatter: {
            name: "routeLink",
            to: "company",
            params: {
              id: "client_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "cycle",
          name: this.$fn.pgettext("WasteBinReadings", "Cycle"),
        }
          ,
        {
          field: "device_id",
          name: this.$fn.pgettext("WasteBinReadings", "Device ID"),
        }
          ,
        {
          field: "worksheets",
          name: this.$fn.pgettext("WasteBinReadings", "Worksheets"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            separator: ", ",
            formatterContext: "item",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "number",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "worksheet",
              params: {
                id: "id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        ]
        ,
        b_2248226175642056_contextMenu: {
          items: [{
            label: this.$fn.gettext("Delete"),
            command: "remove",
          }
            ,
          ]
          ,
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Waste Bin Readings"),
        icon: this.$config.wasteBin.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_1990_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_1990, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_1992_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_1992, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_1996_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_1996, alias=undefined
    return {
      grid: "wasteBinReadings",
    }
  }

  async act_2248226175642056_request_1994_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2248226175642056_request_1994, alias=undefined
    return {
      operation: "waste_bins/delete_reading",
      data: { identities: [$event.data.data.id] },
    }
  }

  async evh_2248226175642056_contextmenuRemove(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_contextmenuRemove.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_1998_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_1998, alias=showWasteBinReadingModal
    return {
      name: "WasteBinReadingModal",
      props: {
        objectId: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_1997_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_1997, alias=undefined
    return $event.data.column.id === 'timestamp'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_showModal_2000_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_2000, alias=undefined
    return {
      name: "CreateWorksheetsFromWasteBinReadingsModal",
      props: {
        readings: _.map(this.selectedItems, p => p.id),
      }
      ,
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_reloadSlickgrid_2004_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6705964765214521_reloadSlickgrid_2004, alias=undefined
    return {
      grid: "wasteBinReadings",
    }
  }

  async act_6705964765214521_request_2002_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6705964765214521_request_2002, alias=deleteItems
    return {
      operation: "waste_bins/delete_readings",
      data: { identities: this.selectedItems.map(p => p.id) },
    }
  }

  async act_6705964765214521_request_2002_getConfirm($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_6705964765214521_request_2002, alias=deleteItems
    return {
      header: "_(\"Delete the selected readings?\")",
      message: this.$fn.gettext("This action cannot be undone."),
      btnOk: this.$fn.gettext("Delete"),
    }
  }

  async evh_6705964765214521_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_1990: actions.CloseModalAction;
    evh_7315092382398562_close_1989: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_1992: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_1991: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_reloadSlickgrid_1996: actions.ReloadSlickgridAction;
    evh_2248226175642056_success_1995: actions.EventHandlerImpl;
    act_2248226175642056_request_1994: actions.RequestAction;
    evh_2248226175642056_contextmenuRemove_1993: actions.EventHandlerImpl;
    evh_2248226175642056_contextmenuRemove: actions.EventHandlerGroup;
    act_2248226175642056_showModal_1998: actions.ShowModalAction;
    evh_2248226175642056_command_1997: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_8320016629450276_showModal_2000: actions.ShowModalAction;
    evh_8320016629450276_click_1999: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_6705964765214521_reloadSlickgrid_2004: actions.ReloadSlickgridAction;
    evh_6705964765214521_success_2003: actions.EventHandlerImpl;
    act_6705964765214521_request_2002: actions.RequestAction;
    evh_6705964765214521_click_2001: actions.EventHandlerImpl;
    evh_6705964765214521_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_1990 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_1990_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_1989 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_1990,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_1989],
      }
    );
    const act_2248226175642056_setData_1992 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_1992_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_1991 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_1992,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_1991],
      }
    );
    const act_2248226175642056_reloadSlickgrid_1996 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_1996_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_success_1995 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_1996,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_request_1994 = new actions.RequestAction(
      {
        actionArgs: this.act_2248226175642056_request_1994_getActionArgs,
        events: [evh_2248226175642056_success_1995],
      }
    );
    const evh_2248226175642056_contextmenuRemove_1993 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_request_1994,
        event: "contextmenu:remove",
        displayName: "request",
      }
    );
    const evh_2248226175642056_contextmenuRemove = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_contextmenuRemove_1993],
      }
    );
    const act_2248226175642056_showModal_1998 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_1998_getActionArgs,
        displayName: "showWasteBinReadingModal",
        events: [],
      }
    );
    const evh_2248226175642056_command_1997 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_1998,
        event: "command",
        when: this.evh_2248226175642056_command_1997_getWhen,
        displayName: "showWasteBinReadingModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_1997],
      }
    );
    const act_8320016629450276_showModal_2000 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_2000_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_click_1999 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_2000,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_1999],
      }
    );
    const act_6705964765214521_reloadSlickgrid_2004 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6705964765214521_reloadSlickgrid_2004_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_success_2003 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_reloadSlickgrid_2004,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_6705964765214521_request_2002 = new actions.RequestAction(
      {
        actionArgs: this.act_6705964765214521_request_2002_getActionArgs,
        confirm: this.act_6705964765214521_request_2002_getConfirm,
        displayName: "deleteItems",
        events: [evh_6705964765214521_success_2003],
      }
    );
    const evh_6705964765214521_click_2001 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_request_2002,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_6705964765214521_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_click_2001],
      }
    );
    return {
      act_7315092382398562_closeModal_1990,
      evh_7315092382398562_close_1989,
      evh_7315092382398562_close,
      act_2248226175642056_setData_1992,
      evh_2248226175642056_selectedRowsChanged_1991,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_reloadSlickgrid_1996,
      evh_2248226175642056_success_1995,
      act_2248226175642056_request_1994,
      evh_2248226175642056_contextmenuRemove_1993,
      evh_2248226175642056_contextmenuRemove,
      act_2248226175642056_showModal_1998,
      evh_2248226175642056_command_1997,
      evh_2248226175642056_command,
      act_8320016629450276_showModal_2000,
      evh_8320016629450276_click_1999,
      evh_8320016629450276_click,
      act_6705964765214521_reloadSlickgrid_2004,
      evh_6705964765214521_success_2003,
      act_6705964765214521_request_2002,
      evh_6705964765214521_click_2001,
      evh_6705964765214521_click,
      showWasteBinReadingModal: act_2248226175642056_showModal_1998,
      deleteItems: act_6705964765214521_request_2002,
    }
  }
}

Vue.component("WasteBinReadings", WasteBinReadings);

</script>